import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "columns container mb-4" }
const _hoisted_2 = { class: "column is-full-mobile is-half-desktop" }
const _hoisted_3 = { class: "quiz-image mb-4" }
const _hoisted_4 = { class: "is-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dynamic_image = _resolveComponent("dynamic-image")!
  const _component_quiz_failed_details = _resolveComponent("quiz-failed-details")!
  const _component_quiz_info = _resolveComponent("quiz-info")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "head mb-2" }, [
      _createElementVNode("div", { class: "p-3" }, "Skill Assessment"),
      _createElementVNode("hr", { class: "m-0" })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_dynamic_image, { image: _ctx.quizImage }, null, 8, ["image"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "has-text-centered bold-text is-size-5 mb-5" }, "Skill Assessment Attempts Exceeded", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "has-text-centered mb-4" }, " You've reached the maximum number of attempts for this skills assessment. ", -1)),
            _createVNode(_component_quiz_failed_details)
          ])
        ])
      ]),
      _createVNode(_component_quiz_info)
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
  ], 64))
}